import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Button from '../../../../components/common/Button';
import Radio from '../../../../components/common/Radio';
import {
  getHousingFundsCheck,
  getHousingFundsCheckSave,
  resetCheckList,
} from '../housingFundsSlice';
import { formatNumber, getAlertMessageFunction, magamCertifyCheck } from '../../../../common/Util';
import Typography from '../../../../components/common/Typography';
import { calculateInitialDisplay03, handleDisplayKey03 } from '../util';
import TextField from '../../../../components/common/TextField';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';

// 주택 마련 저축 공제요건 체크 컴포넌트
const Type3 = ({ onClose, isOpen, onOpen, document }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t: tCommon } = useTranslation('common');
  const { checkList1, salary } = useSelector(state => state.housingFunds);
  const { isMagam, isCertify } = useSelector(state => state.common);
  const [checkList, setCheckList] = useState([]);
  const [displayKeys, setDisplayKeys] = useState(['1', '2', '3']);
  const [alertToShow, setAlertToShow] = useState(null);

  useEffect(() => {
    if (isOpen) {
      dispatch(getHousingFundsCheck({ hInType: '3' }));
    }

    return () => {
      dispatch(resetCheckList());
    };
  }, [dispatch, isOpen]);

  // 초기 displayKeys 설정을 위한 useEffect
  useEffect(() => {
    if (checkList1) {
      setCheckList(checkList1);
      const initialDisplayKeys = calculateInitialDisplay03(checkList1, salary);
      setDisplayKeys(initialDisplayKeys);
    }
  }, [checkList1, salary]);

  useEffect(() => {
    const alertMessage = getAlertMessageFunction();
    if (alertToShow) {
      alertMessage(alertToShow);
      setAlertToShow(null); // 알림 표시 후 상태 초기화
    }
  }, [alertToShow]);

  // 라디오 버튼 변경 핸들러
  const handleRadioChange = (htmSeq, value) => {
    setCheckList(prevList => {
      const {
        newList,
        newDisplayKeys,
        alertToShow: newAlert,
      } = handleDisplayKey03(prevList, displayKeys, salary, htmSeq, value);

      console.log('newDisplayKeys', newDisplayKeys);
      console.log('newList', newList);
      setDisplayKeys(newDisplayKeys);

      if (newAlert) {
        setAlertToShow(newAlert); // 알림 메시지를 상태로 설정
      }

      return newList;
    });
  };

  // 제출 핸들러
  const handleSubmit = () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }
    const alertMessage = getAlertMessageFunction();

    // 현재 display 상태인 항목들 체크
    const isAllChecked = displayKeys.every(
      key => checkList.find(item => item.htmSeq === key)?.htmValue != null,
    );

    const error = checkList.find(item => {
      if (item.htmAlert) {
        return checkList.find(i => i.htmSeq === item.htmSeq)?.htmValue === '2';
      }
      return false;
    });

    console.log('error', error);

    let result = true;
    if (!isAllChecked || error !== undefined) {
      alertMessage('공제요건이 맞지 않아 공제가 불가능합니다.');
      result = false;
    }
    saveApi(result);
  };

  const saveApi = async result => {
    console.log('result', result);
    const alertMessage = getAlertMessageFunction();
    let setData = { cmd: 'S1010E', flag: result ? 'ok' : '', hInType: '3', htmCnt: 6 };
    checkList.forEach(item => {
      let key = '';
      if (Number(item.htmSeq) >= 10) key = 'htm0' + item.htmSeq + 'S';
      else key = 'htm00' + item.htmSeq + 'S';
      setData[key] = item.htmValue || '';
    });

    try {
      const response = await dispatch(getHousingFundsCheckSave(setData)).unwrap();
      if (response.resultCode === 'OK') {
        if (result) {
          alertMessage(tCommon('alertMessage.saveSuccess'));
          if (document) {
            onClose();
          } else {
            onOpen('type3', 'detail');
          }
        }
      } else {
        alertMessage(tCommon('alertMessage.saveFail'));
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <SlideRightDialog onClose={onClose} isOpen={isOpen}>
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        {checkList
          .filter(item => displayKeys.includes(item.htmSeq))
          .map(item => {
            const isCheckedYes = item.htmValue === '1';
            const isCheckedNo = item.htmValue === '2';

            return (
              <div
                className="displayFlexColumn"
                key={item.htmSeq}
                id={`t${item.htmSeq}`}
                style={{ gap: '16px' }}>
                <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
                  {item.htmText}
                </Typography>
                <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
                  <Radio
                    name={`htm${item.htmSeq.toString().padStart(3, '0')}S`}
                    value="1"
                    checked={isCheckedYes}
                    onChange={() => handleRadioChange(item.htmSeq, '1')}
                    label={tCommon('radioGroup.yes')}
                  />
                  <Radio
                    name={`htm${item.htmSeq.toString().padStart(3, '0')}S`}
                    value="2"
                    checked={isCheckedNo}
                    onChange={() => handleRadioChange(item.htmSeq, '2')}
                    label={tCommon('radioGroup.no')}
                  />
                </div>
              </div>
            );
          })}

        <Button value={tCommon('housingFundsCheckList.button1')} fullWidth onClick={handleSubmit} />
      </div>
    </SlideRightDialog>
  );
};

export default Type3;
